import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { ConfigurationProfile } from '../interfaces/configuration-profile';
import { apiResult } from '../../global/operators/api-result';
import { APIResult } from '../../global/interfaces/api-result';
import { ConfigurationProfileWrite } from '../interfaces/configuration-profile-write';

//
@Injectable({
  providedIn: 'root',
})
export class ConfigurationProfileService {
  private controllerBase = 'api/configurationprofile';

  constructor(private http: HttpClient) {}

  create(profile: ConfigurationProfileWrite): Observable<ConfigurationProfile> {
    return this.http
      .post<APIResult<ConfigurationProfile>>(`${this.controllerBase}`, profile)
      .pipe(apiResult());
  }

  get(): Observable<ConfigurationProfile[]> {
    return this.http
      .get<APIResult<{ $id: number; $values: ConfigurationProfile[] }>>(`${this.controllerBase}`)
      .pipe(apiResult())
      .pipe(map((r) => r.$values));
  }

  getUsersConfigurations(): Observable<ConfigurationProfile[]> {
    return this.http
      .get<APIResult<{ $id: number; $values: ConfigurationProfile[] }>>(`${this.controllerBase}/user`)
      .pipe(apiResult())
      .pipe(map((r) => r.$values));
  }

  getTerrainConfigurations(id: string): Observable<ConfigurationProfile[]> {
    return this.http
      .get<APIResult<{ $id: number; $values: ConfigurationProfile[] }>>(
        `${this.controllerBase}/terrains/${id}`
      )
      .pipe(apiResult())
      .pipe(map((r) => r.$values));
  }

  getGlobalConfigurations(): Observable<ConfigurationProfile[]> {
    return this.http
      .get<APIResult<{ $id: number; $values: ConfigurationProfile[] }>>(`${this.controllerBase}/global`)
      .pipe(apiResult())
      .pipe(map((r) => r.$values));
  }

  getOrganizationConfigurations(): Observable<ConfigurationProfile[]> {
    return this.http
      .get<APIResult<{ $id: number; $values: ConfigurationProfile[] }>>(
        `${this.controllerBase}/organization`
      )
      .pipe(apiResult())
      .pipe(map((r) => r.$values));
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.controllerBase}/delete/${id}`);
  }
}
